export enum Roles {
  ADMIN = 'admin',
  SALES = 'sales',
  OPERATIONS = 'operations',
  FINANCE = 'finance',
  MARKETING = 'marketing',
  SUPPORT = 'support',
  STANDARD = 'standard',
}
